module.exports = __webpack_public_path__ + "static/media/backgroundImg.758c812d.png";